import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../user.service';

@Component({
  selector: 'app-add-notes-popup',
  templateUrl: './add-notes-popup.component.html',
  styleUrls: ['./add-notes-popup.component.css']
})
export class AddNotesPopupComponent implements OnInit {

  @Input() public casedata;
  notes: any;

  constructor(public activeModal: NgbActiveModal
    , private userService: UserService) { }

  ngOnInit() {
  }

  onCancel() {
    this.activeModal.close();
  }

  saveNotes() {
    const savedata = { noteText: this.notes, caseId: this.casedata.caseId };
    this.userService.saveCaseNotes(savedata).subscribe((result: any) => {
      this.onCancel();
    });
  }

}
